/* unplugin-vue-components disabled */import script from "./sustainability-banner.vue?vue&type=script&lang=js"
export * from "./sustainability-banner.vue?vue&type=script&lang=js"

import "./sustainability-banner.vue?vue&type=style&index=0&id=677929c3&lang=scss"

const __exports__ = script;

export default __exports__